export function IsNullOrEmpty(str) {
    return (str === "" || str === null || str === undefined || str === "undefined" || str === "null")
}

